import { z } from 'zod'
import {
  ReservationStatusSchema,
  ReservationFailureReasonSchema,
  ReservedLotSchema,
} from './list.schema'

export const Sale1010GetResultSchema = z.object({
  number: z.string(),
  date: z.coerce.date(),
  deliveryDate: z.coerce.date(),
  deliveryShift: z.string().nullable(),
  partyId: z.number().nullable(),
  itemId: z.number(),
  refNo: z.string().nullish(),
  refDate: z.string().nullish(),
  remark: z.string().nullish(),
  status: z.number(),
  qty: z.number(),
  reservationStatus: ReservationStatusSchema,
  reservationFailureCount: z.number(),
  lastReservationAttemptAt: z.coerce.date().nullable(),
  reservedAt: z.coerce.date().nullable(),
  reservationFailureReason: ReservationFailureReasonSchema,
  reservationFailureMessage: z.string().nullable(),
  relatedInv2210DocumentId: z.number().nullable(),
  totalReservedQty: z.number(),
  isFullyReserved: z.boolean(),
  reservedLots: z.array(ReservedLotSchema),
})

export type Sale1010GetResultModel = z.input<typeof Sale1010GetResultSchema>
